"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var field_descriptor_1 = require("./field-descriptor");
var ProtoBufField = /** @class */ (function () {
    function ProtoBufField(fieldNumber, type, values) {
        this.fieldNumber = fieldNumber;
        this.type = type;
        this.values = values;
    }
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    ProtoBufField.prototype.toSimple = function (prefix) {
        prefix = prefix !== null && prefix !== void 0 ? prefix : '';
        if (this.type != field_descriptor_1.default.TYPE_MESSAGE) {
            // Values of a protobuf field of type other than message are never protobuf fields
            var fieldName_1 = this.toFieldName(prefix);
            var content = (this.values.length > 1 ? this.values : this.values[0]);
            var ret_1 = {};
            ret_1[fieldName_1] = content;
            return ret_1;
        }
        var newPrefix = this.fieldNumber > 0 ? "" + prefix + this.fieldNumber + "." : '';
        var submsgsMerged = {};
        this.values.forEach(function (value) {
            var submsg = value.toSimple(newPrefix);
            // Each sub-message has exactly 1 item because it represents 1 protobuf message.
            var fieldName = Object.keys(submsg)[0];
            var valuesToAdd = submsg[fieldName];
            if (!(fieldName in submsgsMerged)) {
                submsgsMerged[fieldName] = valuesToAdd;
            }
            else if (!Array.isArray(submsgsMerged[fieldName])) {
                submsgsMerged[fieldName] = [submsgsMerged[fieldName], valuesToAdd];
            }
            else {
                submsgsMerged[fieldName].push(valuesToAdd);
            }
        });
        if (this.fieldNumber === 0) {
            return submsgsMerged;
        }
        var ret = {};
        var fieldName = this.toFieldName(prefix);
        ret[fieldName] = submsgsMerged;
        return ret;
    };
    ProtoBufField.prototype.toFieldName = function (prefix) {
        return "field_" + prefix + this.fieldNumber;
    };
    return ProtoBufField;
}());
exports.default = ProtoBufField;
